import { FC } from 'react';
import { Question, QuestionOption } from '../../Questionnaire';
import { HandleInputChangeType } from '../Question';
import { Option, OptionInput, OptionLabel, Options } from '../question.styles';

interface Props {
  item: Question;
  selectedAnswers: QuestionOption[];
  handleInputChange: HandleInputChangeType;
}

const BasicQuestionLayout: FC<Props> = ({
  item,
  handleInputChange,
  selectedAnswers,
}) => (
  <Options>
    {item.questionOptions?.map((option) => (
      <Option key={option.id}>
        <OptionInput
          id={option.id}
          name={item.questionId}
          onChange={(e) => handleInputChange(e, option, item.isMultiChoice)}
          type={item.isMultiChoice ? 'checkbox' : 'radio'}
          value={option.value}
          checked={
            selectedAnswers.filter((item) => item.id === option.id).length > 0
          }
        />
        <OptionLabel
          htmlFor={option.id}
          inputType={item.isMultiChoice ? 'checkbox' : 'radio'}
        >
          {option.value}
        </OptionLabel>
      </Option>
    ))}
  </Options>
);

export default BasicQuestionLayout;
